import Seo from "@/components/Seo";
import { PageHero, Section, Btn, SectionHead, Accordion } from "@/components/kit";
import { FAQ_GROUPS } from "@/lib/content";

export default function FAQ() {
  const all = FAQ_GROUPS.flatMap((g) => g.items);
  const jsonLd = {
    "@context": "https://schema.org", "@type": "FAQPage",
    mainEntity: all.map(([q, a]) => ({ "@type": "Question", name: q, acceptedAnswer: { "@type": "Answer", text: a } })),
  };
  return (
    <>
      <Seo title="FAQ" canonical="/faq" description="Common questions about working with Prox: what we do, how engagements start, pricing, sourcing and fit." jsonLd={jsonLd} />
      <PageHero
        eyebrow="FAQ"
        crumbs={[{ label: "Home", to: "/" }, { label: "FAQ" }]}
        title="Questions, answered plainly."
        lead="If your question is not here, the fit call is the fastest way to get a straight answer."
      />
      <Section bg="bone">
        <div className="space-y-16">
          {FAQ_GROUPS.map((g) => (
            <div key={g.title} className="grid lg:grid-cols-12 gap-8">
              <div className="lg:col-span-3"><SectionHead title={g.title} /></div>
              <div className="lg:col-span-9"><Accordion items={g.items.map(([q, a]) => ({ q, a }))} testid={`faq-${g.title.toLowerCase()}`} /></div>
            </div>
          ))}
        </div>
      </Section>
      <Section bg="charcoal" dark className="py-20 md:py-24">
        <div className="max-w-3xl">
          <h2 className="t-display2">Still deciding?</h2>
          <p className="t-lead mt-6 text-[var(--stone)]">The free fit call is twenty minutes and there is no follow-up sequence.</p>
          <Btn to="/book" variant="clay" className="mt-9">Book the fit call</Btn>
        </div>
      </Section>
    </>
  );
}
